function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc from 'dc';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { TileMixin } from '../Mixins/TileMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { StackUtils } from '../Shared/StackUtils';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
import '../Charts.scss';
/**
 * BarChart class is and abstract class that other BarChars are extending.
 */

export var BarChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarChart, _Component);

  function BarChart(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = BarChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        group = _this$props.group,
        groupName = _this$props.groupName,
        groupSelectionFunction = _this$props.groupSelectionFunction,
        stack = _this$props.stack,
        gap = _this$props.gap,
        alwaysUseRounding = _this$props.alwaysUseRounding,
        centerBar = _this$props.centerBar,
        outerPadding = _this$props.outerPadding,
        barPadding = _this$props.barPadding,
        renderLabel = _this$props.renderLabel,
        dimension = _this$props.dimension,
        stackLegend = _this$props.stackLegend,
        brushOn = _this$props.brushOn;
    /*
    const stackLegend = [
      'a','bbb' ,'scdscds', 'f','g','h','i','k'
    ]
    */

    this.chart = dc.barChart(this.chartRef.current); // TODO: Check that this is a valid <test></test>

    if (group && groupName && groupSelectionFunction && stack) {
      this.chart.group(group, stackLegend && stackLegend[0] ? stackLegend[0] : groupName, groupSelectionFunction);

      for (var s = 1; s < stack.length; s++) {
        this.chart.stack(group, stackLegend && stackLegend[s] ? stackLegend[s] : stack[s], StackUtils.selStack(stack[s])); //this.chart.stack(group, 'aaaa' + s, StackUtils.selStack(stack[s]));
      }
    }

    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    MarginsMixin(this.chart, this.props);
    CoordinateGridMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    this.chart.brushOn(brushOn).gap(gap).dimension(dimension).alwaysUseRounding(alwaysUseRounding).centerBar(centerBar).outerPadding(outerPadding).renderLabel(renderLabel);

    if (barPadding > 0) {
      this.chart.barPadding(barPadding);
    }

    this.chart.render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.group !== this.props.group || prevProps.dimension !== this.props.dimension) {
      this.chart.dimension(this.props.dimension).group(this.props.group).redraw();
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart chart bar-chart',
      ref: this.chartRef
    }));
  };

  return BarChart;
}(Component);

_defineProperty(BarChart, "defaultProps", {
  gap: 2,
  round: function round(n) {
    return Math.floor(n);
  },
  alwaysUseRounding: true,
  centerBar: false,
  outerPadding: 0.5,
  barPadding: 0,
  renderLabel: true,
  brushOn: true,
  label: function label(d) {
    return d.y1;
  }
});

BarChart.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Manually set fixed gap (in px) between bars instead of relying on the default auto-generated gap. By default the bar chart implementation will calculate and set the gap automatically based on the number of data points and the length of the x axis. */
  gap: PropTypes.number,

  /** Set or get whether rounding is enabled when bars are centered. If false, using rounding with centered bars will result in a warning and rounding will be ignored. This flag has no effect if bars are not centered. When using standard d3.js rounding methods, the brush often doesn't align correctly with centered bars since the bars are offset. The rounding function must add an offset to compensate, such as in the following example. */
  alwaysUseRounding: PropTypes.bool,

  /** Whether the bar chart will render each bar centered around the data position on the x-axis.r */
  centerBar: PropTypes.bool,

  /** Get or set the outer padding on an ordinal bar chart. This setting has no effect on non-ordinal charts. Will pad the width by `padding * barWidth` on each side of the chart */
  outerPadding: PropTypes.number,

  /** Get or set the spacing between bars as a fraction of bar size. Valid values are between 0-1. Setting this value will also remove any previously set gap. See the d3 docs for a visual description of how the padding is applied. */
  barPadding: PropTypes.number,

  /** `crossfilter` group. Set or get the group attribute of a chart. In dc a group is a crossfilter group. Usually the group should be created from the particular dimension associated with the same chart. If a value is given, then it will be used as the new group. */
  group: PropTypes.object,

  /** `crossfilter` group name. If name is specified then it will be used to generate legend label. */
  groupName: PropTypes.string,

  /** the groupSelectionFunction. TODO ?  */
  groupSelectionFunction: PropTypes.func,

  /** stack to be called in TODO
   * ```
   *  for (var s = 1; s < stack.length; s++) {
   *   this.chart.stack(group, stack[s], StackUtils.selStack(stack[s]));
   *  }
   * ```
   */
  stack: PropTypes.array,

  /** Chart Title */
  chartTitle: PropTypes.string,

  /** Turn on/off label rendering */
  renderLabel: PropTypes.bool,

  /** Function to use to format labels */
  label: PropTypes.func,

  /** Get or set an accessor to order ordinal dimensions. The chart uses crossfilter.quicksort.by to sort elements; this accessor returns the value to order on. */
  ordering: PropTypes.func,

  /** Set order function, to control sorting */
  orderFn: PropTypes.func,

  /** When `alwaysUseRounding` is true. The rounding function must add an offset to compensate, such as in the following example.
   * ```
   * chart.round(function(n) { return Math.floor(n) + 0.5; });
   * ```
   * Deafult value is `Math.floor(n)`
   */
  round: PropTypes.func,

  /** Key name of the chart used by `AVIDashboardContext` in terms of the mapping name and id in the `register` method */
  name: PropTypes.string,

  /** Display brush selector on non orindal charts ?  */
  brushOn: PropTypes.bool,

  /** Set the margins for a particular coordinate grid chart instance. The margins is stored as array. */
  margins: PropTypes.array,

  /** Set the x axis label. */
  xAxisLabel: PropTypes.string,

  /** Set the x axis label padding. If setting the label, you may optionally include additional padding to the margin to make room for the label. By default the padded is set to 12 to accomodate the text height. */
  xAxisLabelPadding: PropTypes.number,

  /** Set the y axis label. */
  yAxisLabel: PropTypes.string,

  /** Set the y axis label padding. If setting the label, you may optionally include additional padding to the margin to make room for the label. By default the padded is set to 12 to accomodate the text height. */
  yAxisLabelPadding: PropTypes.number
} : {};
export default withAVIDashboardContext(BarChart);